import {
  type ArrowPressHandler,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { ComponentProps } from "react";

import { Button, RadioButton } from "@/components";
import { useScrollOnFocus } from "@/utils/use-scoll-on-focus";

type FocusRadioButtonProps = ComponentProps<typeof Button> & {
  onEnterPress: () => void;
  onArrowPress?: ArrowPressHandler;
  scrollOnFocus: boolean;
  focusKey?: string;
  checked?: boolean;
};

export function FocusListRadioButton({
  onEnterPress,
  focusKey,
  scrollOnFocus,
  onArrowPress,
  "data-testid": dataTestId = "focus-list-radio-button",
  active = false,
  ...rest
}: FocusRadioButtonProps): JSX.Element {
  const { ref, focused } = useFocusable({
    onEnterPress,
    focusKey,
    onArrowPress,
  });

  useScrollOnFocus({
    enabled: scrollOnFocus,
    focused,
    ref,
  });

  return (
    <RadioButton
      {...rest}
      ref={ref}
      data-testid={`${dataTestId}.radio-button`}
      focused={focused}
      checked={active}
      active={active}
    />
  );
}
